type ContentFactoryLinked = { contentFactoryPostId?: string | null };

export type CalendarActivity = {
  post?: ContentFactoryLinked;
  draft?: ContentFactoryLinked;
  group?: ContentFactoryLinked;
};

export function isContentFactoryActivity(activity: CalendarActivity): boolean {
  const item = activity.post ?? activity.draft ?? activity.group;
  return !!item?.contentFactoryPostId;
}
